import { Alert, Container, Snackbar, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import Appbar from '../components/Appbar';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { selectSnackbar, setSnackbar } from '../services/appSlice/appSlice';

const KnockoutContainer = () => {
  const snackbar = useAppSelector(selectSnackbar);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const location = useLocation();
  const isCreateSepPage = location.pathname === '/create';
  const isKnockoutScreen = location.pathname.startsWith('/knockout/');
  const useCenteredCanvas = isCreateSepPage || isKnockoutScreen;
  const pageBackground = isCreateSepPage && theme.palette.mode !== 'dark'
    ? '#f5f5f5'
    : theme.palette.mode === 'dark'
      ? theme.palette.background.default
      : '#fff';

  useEffect(() => {
    document.body.style.backgroundColor = pageBackground;
  }, [pageBackground]);

  return (
    <>
      <Appbar />
      <Container
        sx={{
          alignItems: useCenteredCanvas ? 'stretch' : 'center',
          display: 'flex',
          flexGrow: 1,
          minWidth: useCenteredCanvas ? 0 : '100vw',
          width: useCenteredCanvas ? '100vw !important' : undefined,
          maxWidth: useCenteredCanvas ? 'none !important' : undefined,
          margin: useCenteredCanvas ? 0 : undefined,
          backgroundColor: pageBackground,
          p: useCenteredCanvas ? 0 : 2,
          minHeight: '90vh',
          flexDirection: 'column',
        }}
      >
        <Outlet />
      </Container>
      <Snackbar
        key={snackbar?.text}
        open={!!snackbar}
        onClick={() => dispatch(setSnackbar(null))}
      >
        <Alert severity={snackbar?.type}>{snackbar?.text}</Alert>
      </Snackbar>
    </>
  );
};

export default KnockoutContainer;
